import Controller from "./corporateTransportationSubmission.controller";
import template from "./corporateTransportationSubmission.html";

const corporateTransportationSubmission = {
  template,
  controller: Controller,
};

export default corporateTransportationSubmission;



// WEBPACK FOOTER //
// ./src/pages/corporateTransportationSubmission/corporateTransportationSubmission.component.js